import { isBefore, subYears } from 'date-fns'

export default function minimalDate(date, minimalAge) {
  const dataLimite = subYears(new Date(), minimalAge)
  return isBefore(date, dataLimite)
}
